import { STATE } from "../../classes/Enum";
import DeferredImage from "./DeferredImage";
import { CDN_BASE_URL } from "../../helper/image";

const BannerImage = ({product, position}) => {
  const imgSrc = product.type === STATE.CARD
    ? `${CDN_BASE_URL}/imgs/${product.setId}-high.png`
    : `${CDN_BASE_URL}/products/${product.name}.PNG`;

  return (
    <div className={`banner-img ${position}`}>
        <DeferredImage src={imgSrc} />
        </div>
    );

}

export default BannerImage;
